import {gql} from '@apollo/client';

const ProductBooking = gql`
    fragment ProductBooking on ProductPurchase {
        __typename
        productPurchaseId
        purchaseDate
        amount
        bookedPrice
        pricingGroupId
        productAvailability {
            product {
                title
                pricing {
                    adHocPrice
                    pricingGroupId
                }
            }
        }
    }
`;

const SessionBooking = gql`
    fragment SessionBooking on SessionPurchase {
        __typename
        sessionPurchaseId
        purchaseDate
        pricingGroupId
        bookedPrice
        sessionTime {
            from
            to
        }
        sessionAvailability {
            timeRange {
                from
                to
            }
            session {
                pricing {
                    adHocPrice
                    pricingGroupId
                    period
                }
                title
            }
        }
    }
`;

export const Purchase = gql`
    fragment Purchase on Purchase {
        child {
            id
            name {
                fullName
            }
            profileImage {
                url
            }
        }
        approvedAt
        approvedBy {
            name {
                fullName
            }
        }
        rejectedAt
        rejectedBy {
            name {
                fullName
            }
        }
        discountAmount
        id
        type
        invoiceStatus
        invoicesWithoutLines {
            invoiceId
            invoiceDate
        }
        productBookings {
            ...ProductBooking
        }
        sessionBookings {
            ...SessionBooking
        }
    }
    ${ProductBooking}
    ${SessionBooking}
`;

export const Purchases = gql`
    query Purchases(
        $childIds: [ChildId!]
        $childId: ChildId
        $institutionSetIds: [InstitutionSetId!]
        $institutionSetId: InstitutionSetId
        $approved: Boolean
        $count: Int
        $after: PurchaseCursor
        $ordering: PurchaseOrdering
    ) {
        finance {
            purchases {
                filter(
                    childIds: $childIds
                    institutionSetIds: $institutionSetIds
                    approved: $approved
                    rejected: false
                    count: $count
                    after: $after
                    ordering: $ordering
                ) {
                    purchases {
                        ...Purchase
                        ordering(ordering: $ordering)
                    }
                    cursor
                }
                rejected: filter(
                    childIds: $childIds
                    institutionSetIds: $institutionSetIds
                    approved: false
                    rejected: true
                    count: $count
                    after: $after
                    ordering: $ordering
                ) {
                    purchases {
                        ...Purchase
                        ordering(ordering: $ordering)
                    }
                    cursor
                }
                behaviors(childId: $childId, institutionSetId: $institutionSetId) {
                    behaviorId
                    ... on BehaviorCanCreatePurchase {
                        autoApprove
                    }
                }
            }
        }
    }
    ${Purchase}
`;
